import { render, staticRenderFns } from "./TimberPersonInfoForm.vue?vue&type=template&id=b170018c&scoped=true&"
import script from "./TimberPersonInfoForm.vue?vue&type=script&lang=js&"
export * from "./TimberPersonInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b170018c",
  null
  
)

export default component.exports